<template>
    <NavBar />
    Settings
</template>
<script>
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'SettingsView',
  components: {
      NavBar
  }
}
</script>
<style>
.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}
</style>